<template>
    <div class="content-wrapper">
        <section class="content-header">
            <div class="row">
                <div class="col-xs-10">
                    <h1>Coupon List</h1>
                </div>
                <div class="col-xs-2">
                    <router-link :to="{path: 'addcoupon'}" class="btn btn-sm btn-add">
                        <i class="fa fa-plus-square"></i> Add New Coupon
                    </router-link>
                </div>
            </div>
        </section>
        <section class="content">
            <form v-on:submit.prevent="dopagination(0)">
                <div class="row">
                    <div class="col-xs-6 col-sm-3 form-group">
                        <input placeholder="Coupon Code" type="text" v-model="coupon_code" name="coupon_code"
                               id="coupon_code" class="form-control input-sm" value="" autocomplete="off">
                    </div>
                    <div class="col-xs-6 col-sm-3 form-group">
                        <select class="form-control input-sm" v-model="discount_type" id="discount_type">
                            <option value="">All Discount Types</option>
                            <option value="fixed">Fixed Amount</option>
                            <option value="percentage">Percentage</option>
                        </select>
                    </div>
                    <div class="col-xs-6 col-sm-3 form-group" style="margin-bottom: 0;">
                        <select title="" name="limit" id="limit" class="form-control input-sm select2"
                                @change="dopagination(0);" v-model="display_limit" v-select="display_limit">
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50" selected>50</option>
                            <option value="75">75</option>
                            <option value="100">100</option>
                        </select>
                    </div>
                    <div class="col-xs-6 col-sm-3 form-group btnLeft">
                        <a class="btn btn-sm btn-search" id="apply" @click="dopagination(0);">
                            <i class="fa fa-search"></i> Search
                        </a>
                    </div>
                </div>
            </form>
            <div class="row">
                <div class="col-sm-12">
                    <div class="alert alert-success" v-if="success_message">
                        {{success_message}}
                    </div>
                    <div class="alert alert-danger" v-if="error_message">
                        {{error_message}}
                    </div>
                    <div class="alert alert-info" v-if="alert_message">
                        {{alert_message}}
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="box" id="pagination">
                        <div class="box-header">
                            <h3 class="box-title">
                                Total : {{totalData}} Showing {{dispplayFrom}} to {{dispplayTo}}
                            </h3>
                        </div>
                        <div class="box-body">
                            <div class="table-responsive">
                                <table class="table table-0024 table-bordered table-striped">
                                    <thead>
                                    <tr>
                                        <th class="tdCenter tdSN">SN</th>
                                        <th class="tdCenter">Coupon Code</th>
                                        <th class="tdCenter">Discount Type</th>
                                        <th class="tdCenter">Discount Value</th>
                                        <th class="tdCenter">Validity Period</th>
                                        <th class="tdCenter">Usage Type</th>
                                        <th class="tdCenter">Max Uses</th>
                                        <th class="tdCenter">Stripe Coupon</th>
                                        <th class="tdCenter">Status</th>
                                        <th class="tdCenter">Action</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(data, index) in coupons" :key="data.id">
                                        <td class="tdCenter tdSN">
                                            {{parseInt(sl) + parseInt(index)}}
                                        </td>
                                        <td class="tdCenter">
                                            {{data.coupon_code}}
                                        </td>
                                        <td class="tdCenter">
                                            {{data.discount_type === 'fixed' ? 'Fixed' : 'Percentage'}}
                                        </td>
                                        <td class="tdCenter">
                                            {{data.discount_value}} {{data.discount_type === 'fixed' ? currencySymbol : '%'}}
                                        </td>
                                        <td class="tdCenter">
                                            {{formatDate(data.start_date)}} to {{formatDate(data.end_date)}}
                                        </td>
                                        <td class="tdCenter">
                                            {{data.usage_type === 'one_time' ? 'One-time' : 'Recurring'}}
                                        </td>
                                        <td class="tdCenter">
                                            {{data.max_uses}}
                                        </td>
                                        <td class="tdCenter">
                                            {{data.stripe_coupon_id || 'N/A'}}
                                        </td>
                                        <td class="tdCenter">
                                            <span class="label label-success" v-if="data.status === 'active'">Active</span>
                                            <span class="label label-danger" v-else>Inactive</span>
                                        </td>
                                        <td class="tdCenter">
                                            <router-link :to="{ name: 'EditCoupon', params: {id: data.id } }"
                                                         title="Edit Coupon">
                                                <i class="ion ion-ios-compose table-edit"></i>
                                            </router-link>
                                            <a href="#" @click="confirmDelete(data.id)" title="Delete Coupon" class="delete-btn">
                                                <i class="ion ion-ios-trash table-delete"></i>
                                            </a>
                                        </td>
                                    </tr>
                                    <tr v-if="coupons.length==0">
                                        <td colspan="10" class="tdCenter" style="padding: 30px 0;">
                                            <b>No Records Found</b>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="pagination" v-if="last_page > 1">
                                <a v-if="prev_page_url" href="#" @click="dopagination(prevPage)" class="next">
                                    « Previous
                                </a>
                                <span v-else class="disabled">« Previous</span>
                                <span v-if="last_page > max_display_pagination">
                                    <span v-for="index in last_page">
                                        <span v-if="index==1||index==2">
                                            <span class="current" v-if="index==current_page">
                                                {{index}}
                                            </span>
                                            <span v-else>
                                                <a href="#" @click="dopagination(index)">
                                                    {{index}}
                                                </a>
                                            </span>
                                            <span v-if="(index==2) && firstDotted">..</span>
                                        </span>
                                        <span v-if="randomPageNumber.includes(index)">
                                            <span class="current" v-if="index==current_page">
                                                {{index}}
                                            </span>
                                            <span v-else>
                                                <a href="#" @click="dopagination(index)">
                                                    {{index}}
                                                </a>
                                            </span>
                                        </span>
                                        <span v-if="index==last_page||index==last_page-1">
                                            <span v-if="(index==last_page-1) && lastDotted">
                                                ..
                                            </span>
                                            <span class="current" v-if="index==current_page">
                                                {{index}}
                                            </span>
                                            <span v-else>
                                                <a href="#" @click="dopagination(index)">
                                                    {{index}}
                                                </a>
                                            </span>
                                        </span>
                                    </span>
                                </span>
                                <span v-else>
                                    <span v-for="index in last_page">
                                        <span class="current" v-if="index==current_page">
                                            {{index}}
                                        </span>
                                        <span v-else>
                                            <a href="#" @click="dopagination(index)">{{index}}</a>
                                        </span>
                                    </span>
                                </span>
                                <a v-if="next_page_url" href="#" @click="dopagination(nextPage)" class="next">
                                    Next »
                                </a>
                                <span v-else class="disabled">Next »</span>
                            </div>
                        </div>
                        <div class="box-footer"></div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        name: "CouponList",
        data() {
            return {
                coupons: [],
                coupon_code: '',
                discount_type: '',
                alert_message: '',
                success_message: '',
                error_message: '',
                dispplayFrom: 0,
                dispplayTo: 0,
                totalData: 0,
                display_limit: 50,
                status: '',
                sl: 1,
                currencySymbol: '$', // Change this to your currency symbol

                // Pagination Variables
                prev_page_url: false,
                next_page_url: false,
                last_page: 1,
                current_page: null,
                max_display_pagination: 9,
                randomPageNumber: {},
                firstDotted: false,
                lastDotted: false,
                prevPage: '',
                nextPage: '',
            }
        },
        created() {
            this.loadCouponList();
            
            // Check for success message from previous page
            if (this.$route.query.success) {
                this.success_message = 'Coupon ' + (this.$route.query.action || 'processed') + ' successfully';
                setTimeout(() => {
                    this.success_message = '';
                    // Remove the query parameter from URL
                    this.$router.replace({ query: null });
                }, 5000);
            }
        },
        methods: {
            loadCouponList() {
                loader.show();
                var rootObject = this;
                axios.get('coupons').then(function (response) {
                    rootObject.populateData(response);
                })
                .catch(function (error) {
                    console.log(error);
                    let alertmessage = "";
                    for (var prop in error.response.data) {
                        alertmessage += ' ' + error.response.data[prop]
                    }
                    console.log(alertmessage);
                    loader.hide();
                    rootObject.com_errorHandel(error);
                });
            },
            
            dopagination(page_no = '') {
                loader.show();
                var rootObject = this;

                let querystr = `coupon_code=${this.coupon_code}&discount_type=${this.discount_type}&paginate=${this.display_limit}`;
                if (page_no > 0) {
                    querystr += "&page=" + page_no;
                }

                axios.get('coupons?' + querystr).then(function (response) {
                    rootObject.populateData(response);
                })
                .catch(function (error) {
                    let alertmessage = "";
                    for (var prop in error.response.data) {
                        alertmessage += ' ' + error.response.data[prop]
                    }
                    console.log(alertmessage);
                    loader.hide();
                    rootObject.com_errorHandel(error);
                });
            },

            populateData(response) {
                var responseData = response.data.batchData;
                this.sl = parseInt(responseData.from);
                this.coupons = responseData.data;
                this.totalData = responseData.total;
                this.dispplayFrom = responseData.from;
                this.dispplayTo = responseData.to;
                this.display_limit = responseData.per_page;
                this.paginationGenerate(responseData);
                loader.hide();
            },

            paginationGenerate(response) {
                this.prev_page_url = response.prev_page_url;
                this.next_page_url = response.next_page_url;
                this.last_page = response.last_page;
                this.current_page = response.current_page;
                this.randomPageNumber = [];
                this.firstDotted = false;
                this.lastDotted = false;
                this.prevPage = this.current_page - 1;
                this.nextPage = this.current_page + 1;
                let countableOtherPages = this.max_display_pagination - 4;
                
                if (this.current_page == 1 || this.current_page == 2) {
                    for (let i = 3; i <= (3 + (countableOtherPages - 1)); i++) {
                        this.randomPageNumber.push(i);
                    }
                    this.lastDotted = true;
                } else if (this.current_page == this.last_page || this.current_page == this.last_page - 1) {
                    let endPage = this.last_page - 2;
                    for (let i = endPage; i >= endPage - (countableOtherPages - 1); i--) {
                        this.randomPageNumber.push(i);
                    }
                    this.firstDotted = true;
                } else {
                    let interval = parseInt(countableOtherPages / 2);
                    if (this.current_page <= (interval + 3)) {
                        for (let i = 3; i <= (3 + (countableOtherPages - 1)); i++) {
                            this.randomPageNumber.push(i);
                        }
                        this.lastDotted = true;
                    } else if (this.current_page >= (this.last_page - (interval + 2))) {
                        let endPage = this.last_page - 2;
                        for (let i = endPage; i >= endPage - (countableOtherPages - 1); i--) {
                            this.randomPageNumber.push(i);
                        }
                        this.firstDotted = true;
                    } else {
                        for (let i = this.current_page; i <= (this.current_page + interval); i++) {
                            this.randomPageNumber.push(i);
                        }

                        for (let i = (this.current_page - 1); i >= (this.current_page - interval); i--) {
                            this.randomPageNumber.push(i);
                        }
                    }
                }
            },
            
            formatDate(dateString) {
                if (!dateString) return '';
                const options = { year: 'numeric', month: 'short', day: 'numeric' };
                return new Date(dateString).toLocaleDateString(undefined, options);
            },

            confirmDelete(id) {
                if (confirm('Are you sure you want to delete this coupon?')) {
                    this.deleteCoupon(id);
                }
            },

            deleteCoupon(id) {
                loader.show();
                axios.delete(`coupons/${id}`)
                    .then(response => {
                        this.success_message = 'Coupon deleted successfully';
                        this.loadCouponList(); // Refresh the list
                        setTimeout(() => {
                            this.success_message = '';
                        }, 5000);
                        loader.hide();
                    })
                    .catch(error => {
                        console.error('Error deleting coupon:', error);
                        this.error_message = 'Error deleting coupon';
                        setTimeout(() => {
                            this.error_message = '';
                        }, 5000);
                        loader.hide();
                    });
            }
        },
        mounted: function () {
            $(".select2").select2();
        }
    };
</script>

<style scoped>
.tdCenter {
    text-align: center;
}
.tdSN {
    width: 50px;
}
.btn-add {
    background-color: #3c8dbc;
    color: white;
    border-color: #367fa9;
}
.btn-add:hover {
    background-color: #367fa9;
}
.table-edit {
    color: #3c8dbc;
    font-size: 18px;
    margin-right: 10px;
}
.table-delete {
    color: #dd4b39;
    font-size: 18px;
}
.delete-btn {
    margin-left: 10px;
}
.label-success {
    background-color: #00a65a;
}
.label-danger {
    background-color: #dd4b39;
}
.pagination {
    display: inline-block;
    padding-left: 0;
    margin: 20px 0;
    border-radius: 4px;
}
.pagination > span, .pagination > a {
    position: relative;
    float: left;
    padding: 6px 12px;
    margin-left: -1px;
    line-height: 1.42857143;
    color: #337ab7;
    text-decoration: none;
    background-color: #fff;
    border: 1px solid #ddd;
}
.pagination > .current {
    z-index: 2;
    color: #fff;
    cursor: default;
    background-color: #337ab7;
    border-color: #337ab7;
}
.pagination > .disabled {
    color: #777;
    cursor: not-allowed;
    background-color: #fff;
    border-color: #ddd;
}
</style>